// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ZMnmtBoiE2ESml_6NoPhn","posts":"f1GIlrTgnvqKdrCWI17-m","post":"_3wJQFlNqYU-jLsWIXA3b-_","link":"_3rUf2QvWnyLuFHWoH-Nn8H buttonShadow"};